import { useState } from "react"
import { Divider, List, ListItem } from "@mui/material"
import { Else, If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import useLocales from "minimals-template/components/@hooks/useLocales"
import NavList from "./nav-list"
import { GroupHeaderStyle } from "./style"

export default function NavGroup({ group, isCollapse }) {
    const { translate } = useLocales()
    const [userOpen, setUserOpen] = useState(true)

    if (!group.items?.length) return null

    const hasHeader = !!group.group
    const header = typeof group.subheader === "string" ? translate(group.subheader) : group.subheader
    const collapsedLabel = hasHeader && isCollapse ? group.group : undefined
    const open = isCollapse || userOpen

    const rows = (
        <Repeat list={group.items} item={<NavList depth={1} isCollapse={isCollapse} />} pass="data" keyFn={byItemKey} />
    )

    return (
        <If value={hasHeader}>
            <ListItem
                component="li"
                disablePadding
                sx={{ display: "block" }}
                data-cy={`navItem-group-${group.group?.toLowerCase()}`}
            >
                <If value={isCollapse}>
                    <Divider aria-hidden="true" sx={{ my: 1, borderStyle: "dashed", borderColor: "divider" }} />
                </If>
                <details open={open} onToggle={handleToggle}>
                    <GroupHeaderStyle
                        isCollapse={isCollapse}
                        data-cy={`navItem-group-toggle-${group.group?.toLowerCase()}`}
                    >
                        <Iconify
                            aria-hidden="true"
                            icon="material-symbols:arrow-right-rounded"
                            sx={{
                                width: 16,
                                height: 16,
                                mr: 1,
                                transition: (theme) =>
                                    theme.transitions.create("transform", {
                                        duration: theme.transitions.duration.shorter,
                                    }),
                                ...(open && { transform: "rotate(90deg)" }),
                            }}
                        />
                        {header}
                    </GroupHeaderStyle>
                    <List component="ul" role="list" disablePadding aria-label={collapsedLabel}>
                        {rows}
                    </List>
                </details>
            </ListItem>
            <Else>{rows}</Else>
        </If>
    )

    function handleToggle(event) {
        if (isCollapse) return
        setUserOpen(event.currentTarget.open)
    }

    function byItemKey(item) {
        return item.title + item.path
    }
}
